import { render, staticRenderFns } from "./Singup.vue?vue&type=template&id=b5078fe4"
import script from "./Singup.vue?vue&type=script&lang=js"
export * from "./Singup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports